import React, {useContext,useEffect,useState, useRef} from 'react';

import { useNavigate } from "react-router-dom";
import MessageModal from '../MessageModal/MessageModal';

const SessionController = ({messageLostSessionCallback}) => {

    const navigate = useNavigate();
    const [messageModal, setMessageModal] = useState('');
    const messageResponse = useRef([]);  

    const closeMessageModal = () => {
        setMessageModal(false);    
        messageResponse.current = [];
      }

    const openMessageModal = (response) => {    
      if(messageResponse.current.includes(response)){
        return;
      }
      let newMessageResponse = [messageResponse.current,<br/>,<br/>,response];    
      messageResponse.current = newMessageResponse;
      setMessageModal(true);
      setTimeout(() => {            
        navigate('/');
      }, "5000");
    }

    useEffect(() =>{
      if(messageLostSessionCallback === '')
        return;
      openMessageModal(messageLostSessionCallback)
    },[messageLostSessionCallback])

    return (
    <>       
        <MessageModal messageCallback={messageResponse.current} messageModalCallback={messageModal} closeMessageModalCallback={closeMessageModal}/>      
    </>
    
  );
};

export default SessionController;